import {jsx as $k8FG1$jsx, jsxs as $k8FG1$jsxs} from "react/jsx-runtime";
import $k8FG1$classnames from "classnames";
import {createContext as $k8FG1$createContext, forwardRef as $k8FG1$forwardRef, useState as $k8FG1$useState, useMemo as $k8FG1$useMemo, useContext as $k8FG1$useContext, useId as $k8FG1$useId, isValidElement as $k8FG1$isValidElement, cloneElement as $k8FG1$cloneElement, useRef as $k8FG1$useRef, useEffect as $k8FG1$useEffect} from "react";
import {RovingIndexItem as $k8FG1$RovingIndexItem, useMergeRefs as $k8FG1$useMergeRefs, RovingIndexRoot as $k8FG1$RovingIndexRoot, debounce as $k8FG1$debounce} from "@komponentkassen/svv-utils";
import {BreadcrumbArrowLeft as $k8FG1$BreadcrumbArrowLeft, ArrowRightGray as $k8FG1$ArrowRightGray} from "@komponentkassen/svv-icons";




const $bf88a460d410b8aa$export$cfa7aa87c26e7d1f = /*#__PURE__*/ (0, $k8FG1$createContext)({});
const $bf88a460d410b8aa$export$3d9921da20efe72 = /*#__PURE__*/ (0, $k8FG1$forwardRef)(({ children: children , value: value , defaultValue: defaultValue , className: className , onChange: onChange , size: size = "md" , fullWidth: fullWidth = false , ...rest }, ref)=>{
    const isControlled = value !== undefined;
    const [uncontrolledValue, setUncontrolledValue] = (0, $k8FG1$useState)(defaultValue);
    let onValueChange = onChange;
    if (!isControlled) onValueChange = (newValue)=>{
        setUncontrolledValue(newValue);
        onChange?.(newValue);
    };
    const val = (0, $k8FG1$useMemo)(()=>{
        if (!isControlled) return value = uncontrolledValue;
        return undefined;
    }, [
        value,
        uncontrolledValue
    ]);
    return /*#__PURE__*/ (0, $k8FG1$jsx)($bf88a460d410b8aa$export$cfa7aa87c26e7d1f.Provider, {
        value: {
            value: val,
            defaultValue: defaultValue,
            onChange: onValueChange
        },
        children: /*#__PURE__*/ (0, $k8FG1$jsx)("div", {
            className: (0, $k8FG1$classnames)(className, "svv-tabs", `svv-tabs--${size}`, fullWidth && "svv-tabs-full-width"),
            ref: ref,
            ...rest,
            children: children
        })
    });
});
$bf88a460d410b8aa$export$3d9921da20efe72.displayName = "Tabs";







const $2294683a419a20bc$export$9e1f245768e4b012 = /*#__PURE__*/ (0, $k8FG1$forwardRef)((props, ref)=>{
    const { className: className , activeIcon: activeIcon , icon: icon , label: label , ...rest } = props;
    const { value: value , ...restProps } = rest;
    const tabs = (0, $k8FG1$useContext)((0, $bf88a460d410b8aa$export$cfa7aa87c26e7d1f));
    const buttonId = `tab-${(0, $k8FG1$useId)()}`;
    return /*#__PURE__*/ (0, $k8FG1$jsx)((0, $k8FG1$RovingIndexItem), {
        ...rest,
        children: /*#__PURE__*/ (0, $k8FG1$jsxs)("button", {
            id: buttonId,
            "aria-selected": tabs.value === value,
            role: "tab",
            onClick: ()=>{
                tabs.onChange?.(value);
            },
            className: (0, $k8FG1$classnames)(className, "svv-tab-button", tabs.value === value && "svv-tab-button--active"),
            value: value,
            ref: ref,
            ...restProps,
            children: [
                tabs.value === value && !!activeIcon && /*#__PURE__*/ (0, $k8FG1$isValidElement)(activeIcon) && /*#__PURE__*/ (0, $k8FG1$cloneElement)(activeIcon) || !!icon && /*#__PURE__*/ (0, $k8FG1$isValidElement)(icon) && /*#__PURE__*/ (0, $k8FG1$cloneElement)(icon),
                /*#__PURE__*/ (0, $k8FG1$jsx)("span", {
                    children: label
                })
            ]
        })
    });
});
$2294683a419a20bc$export$9e1f245768e4b012.displayName = "SVVTab";










function $5d29eea2ebfb26b0$var$ScrollButton({ hidden: hidden , onClick: onClick , direction: direction  }) {
    return /*#__PURE__*/ (0, $k8FG1$jsx)("div", {
        className: (0, $k8FG1$classnames)("svv-tabs-scroll-button", hidden && "svv-tabs-scroll-button--hidden", direction === "left" && "svv-tabs-scroll-button--left", direction === "right" && "svv-tabs-scroll-button--right"),
        onClick: onClick,
        "aria-hidden": true,
        children: direction === "left" ? /*#__PURE__*/ (0, $k8FG1$jsx)((0, $k8FG1$BreadcrumbArrowLeft), {
            className: "svv-tabs-scroll-button-icon"
        }) : /*#__PURE__*/ (0, $k8FG1$jsx)((0, $k8FG1$ArrowRightGray), {
            className: "svv-tabs-scroll-button-icon"
        })
    });
}
var $5d29eea2ebfb26b0$export$2e2bcd8739ae039 = $5d29eea2ebfb26b0$var$ScrollButton;




function $777828f642d91075$export$7f4e25ad972235a3(listRef) {
    const [displayScroll, setDisplayScroll] = (0, $k8FG1$useState)({
        start: false,
        end: false
    });
    const updateScrollButtonState = (0, $k8FG1$useMemo)(()=>(0, $k8FG1$debounce)(()=>{
            if (!listRef?.current) return;
            const { scrollWidth: scrollWidth , clientWidth: clientWidth  } = listRef.current;
            const scrollLeft = listRef.current.scrollLeft;
            // use 1 for the potential rounding error with browser zooms.
            const showStartScroll = scrollLeft > 1;
            const showEndScroll = scrollLeft < scrollWidth - clientWidth - 1;
            setDisplayScroll((oldDisplayScroll)=>showStartScroll === oldDisplayScroll.start && showEndScroll === oldDisplayScroll.end ? oldDisplayScroll : {
                    start: showStartScroll,
                    end: showEndScroll
                });
        }, 200), [
        listRef
    ]);
    (0, $k8FG1$useEffect)(()=>{
        window.addEventListener("resize", updateScrollButtonState);
        return ()=>{
            window.removeEventListener("resize", updateScrollButtonState);
            updateScrollButtonState.clear();
        };
    }, [
        listRef,
        updateScrollButtonState
    ]);
    (0, $k8FG1$useEffect)(()=>{
        updateScrollButtonState();
    });
    return {
        update: updateScrollButtonState,
        start: displayScroll.start,
        end: displayScroll.end,
        show: displayScroll.end || displayScroll.start,
        scrollLeft: ()=>{
            if (listRef.current) listRef.current.scrollLeft -= 100;
        },
        scrollRight: ()=>{
            if (listRef.current) listRef.current.scrollLeft += 100;
        }
    };
}


const $aaff497715b82ac9$export$131c7a064b10257c = /*#__PURE__*/ (0, $k8FG1$forwardRef)(({ children: children , className: className , ...rest }, ref)=>{
    const listRef = (0, $k8FG1$useRef)(null);
    const mergedRef = (0, $k8FG1$useMergeRefs)([
        listRef,
        ref
    ]);
    const scrollButtonController = (0, $777828f642d91075$export$7f4e25ad972235a3)(listRef);
    return /*#__PURE__*/ (0, $k8FG1$jsxs)("div", {
        className: (0, $k8FG1$classnames)(className, "svv-tab-list-content", !scrollButtonController.show && "svv-tab-list-content--no-scroll", scrollButtonController.show && "svv-tab-list-content--scroll"),
        children: [
            scrollButtonController.show && /*#__PURE__*/ (0, $k8FG1$jsx)((0, $5d29eea2ebfb26b0$export$2e2bcd8739ae039), {
                direction: "left",
                hidden: !scrollButtonController.start,
                onClick: scrollButtonController.scrollLeft
            }),
            /*#__PURE__*/ (0, $k8FG1$jsx)((0, $k8FG1$RovingIndexRoot), {
                role: "tablist",
                className: "svv-tab-list",
                ref: mergedRef,
                onScroll: scrollButtonController.update,
                ...rest,
                children: children
            }),
            scrollButtonController.show && /*#__PURE__*/ (0, $k8FG1$jsx)((0, $5d29eea2ebfb26b0$export$2e2bcd8739ae039), {
                direction: "right",
                hidden: !scrollButtonController.end,
                onClick: scrollButtonController.scrollRight
            })
        ]
    });
});
$aaff497715b82ac9$export$131c7a064b10257c.displayName = "SVVTabList";






const $6954d063370ffe98$export$57fdb37917beb46c = /*#__PURE__*/ (0, $k8FG1$forwardRef)(({ children: children , value: value , className: className , ...rest }, ref)=>{
    const { value: tabsValue  } = (0, $k8FG1$useContext)((0, $bf88a460d410b8aa$export$cfa7aa87c26e7d1f));
    const active = value === tabsValue;
    return active ? /*#__PURE__*/ (0, $k8FG1$jsx)("div", {
        className: (0, $k8FG1$classnames)(className, "svv-tab-content"),
        ref: ref,
        ...rest,
        children: children
    }) : null;
});
$6954d063370ffe98$export$57fdb37917beb46c.displayName = "SVVTabContent";








function $fcb89ea6f45d63c4$export$14e6e60d96d6efb9({ options: options , defaultValue: defaultValue , onChange: onChange , size: size = "md"  }) {
    return /*#__PURE__*/ (0, $k8FG1$jsxs)((0, $bf88a460d410b8aa$export$3d9921da20efe72), {
        defaultValue: defaultValue,
        size: size,
        onChange: onChange,
        children: [
            /*#__PURE__*/ (0, $k8FG1$jsx)((0, $aaff497715b82ac9$export$131c7a064b10257c), {
                children: options.map((o)=>/*#__PURE__*/ (0, $k8FG1$jsx)((0, $2294683a419a20bc$export$9e1f245768e4b012), {
                        value: o.value,
                        label: o.label,
                        activeIcon: o.activeIcon,
                        icon: o.icon
                    }, o.value))
            }),
            options.map((o)=>/*#__PURE__*/ (0, $k8FG1$jsx)((0, $6954d063370ffe98$export$57fdb37917beb46c), {
                    value: o.value,
                    children: o.content
                }, `${o.value}-content`))
        ]
    });
}




export {$bf88a460d410b8aa$export$3d9921da20efe72 as SVVTabs, $2294683a419a20bc$export$9e1f245768e4b012 as SVVTab, $aaff497715b82ac9$export$131c7a064b10257c as SVVTabList, $6954d063370ffe98$export$57fdb37917beb46c as SVVTabContent, $fcb89ea6f45d63c4$export$14e6e60d96d6efb9 as SVVDefaultTabs};
//# sourceMappingURL=module.js.map
